import { SUCCESS_MESSAGES, responseErrorToString } from '@zorro/common-utils';
import { environmentName } from '@zorro/environment';
import {
  callEndpoint,
  showErrorNotification,
  showSuccessNotification,
  useImpersonation,
  useLoadingOverlay,
} from '@zorro/web/ui-utils';
import _noop from 'lodash/noop';

import {
  getFullStorySessionURL,
  isDebugModeEnabled,
} from '../Analytics/AnalyticsUtils';

type TUseSupportInformationFormConfig = {
  onSuccess?: () => void;
};

export function useSupportInformationForm({
  onSuccess = _noop,
}: TUseSupportInformationFormConfig = {}) {
  const { user, employee, authUser, authEmployee, isImpersonated } =
    useImpersonation();

  const { startLoading, stopLoading } = useLoadingOverlay();

  const supportInformation = {
    environment: environmentName(),
    pageURL: window.location.href,
    sessionURL: getFullStorySessionURL(),
    userDetails: {
      isImpersonated,
      user,
      employee,
      authUser,
      authEmployee,
    },
    isAnalyticsDebugMode: isDebugModeEnabled(),
  };

  async function handleSubmit() {
    startLoading();
    try {
      await callEndpoint({
        method: 'supportControllerReportIssue',
        params: [supportInformation],
      });
      showSuccessNotification({
        message: SUCCESS_MESSAGES.SUPPORT_INFORMATION_SENT_SUCCESS,
      });

      onSuccess();
    } catch (error) {
      showErrorNotification({ message: responseErrorToString(error) });
    }
    stopLoading();
  }

  return { supportInformation, handleSubmit };
}
